module.exports = __webpack_public_path__ + "img/video.4b85ab52.png";